/* NDI Product Tabs — active-link toggle + smooth anchor scroll. Vanilla, no deps.
   Ported from old theme product-page-tab inline script. */
(function () {
  var links = document.querySelectorAll('[data-ndi-ptab]');
  if (!links.length) return;

  function setActive(link) {
    links.forEach(function (l) { l.classList.remove('is-active'); });
    if (link) link.classList.add('is-active');
  }

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      setActive(link);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Back-to-top arrows inside panels → scroll to Description + reactivate its tab.
  document.querySelectorAll('[data-ndi-ptab-top]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var desc = document.getElementById('ndi-ptab-description');
      if (desc) desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActive(document.getElementById('ndi-ptab-description-link'));
    });
  });
})();
